import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Organizacia } from '../models';
// @ts-ignore
import { OsobaOrganizacie } from '../models';
// @ts-ignore
import { OsobaOrganizacieAssign } from '../models';
// @ts-ignore
import { OsobaOrganizacieZaradenie } from '../models';
// @ts-ignore
import { OsobaOrganizacieZaradenieCreate } from '../models';
/**
 * OrganizacieApi - axios parameter creator
 * @export
 */
export const OrganizacieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAllowPozadovaneZaradeniaOrganizacie: async (osobaOrganizacieId: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaOrganizacieId' is not null or undefined
            assertParamExists('portalAllowPozadovaneZaradeniaOrganizacie', 'osobaOrganizacieId', osobaOrganizacieId)
            const localVarPath = `/organizacie/{osobaOrganizacieId}/povol-zaradenia`
                .replace(`{${"osobaOrganizacieId"}}`, encodeURIComponent(String(osobaOrganizacieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=utf-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvorenie novej osoby organizácie (režim asociácie Osoby)
         * @param {string} organizaciaId Organizácia ID
         * @param {OsobaOrganizacieAssign} osobaOrganizacieAssign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAssignOrganizaciaOsobaOrganizacie: async (organizaciaId: string, osobaOrganizacieAssign: OsobaOrganizacieAssign, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalAssignOrganizaciaOsobaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'osobaOrganizacieAssign' is not null or undefined
            assertParamExists('portalAssignOrganizaciaOsobaOrganizacie', 'osobaOrganizacieAssign', osobaOrganizacieAssign)
            const localVarPath = `/organizacie/{organizaciaId}/osoby`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(osobaOrganizacieAssign, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Priradenie zaradení osobám organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {Array<OsobaOrganizacieZaradenieCreate>} osobaOrganizacieZaradenieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAssignOrganizaciaZaradeniaOrganizacie: async (organizaciaId: string, osobaOrganizacieZaradenieCreate: Array<OsobaOrganizacieZaradenieCreate>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalAssignOrganizaciaZaradeniaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'osobaOrganizacieZaradenieCreate' is not null or undefined
            assertParamExists('portalAssignOrganizaciaZaradeniaOrganizacie', 'osobaOrganizacieZaradenieCreate', osobaOrganizacieZaradenieCreate)
            const localVarPath = `/organizacie/{organizaciaId}/zaradeniaOsoby`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=utf-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(osobaOrganizacieZaradenieCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOrganizacie: async (organizaciaId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalGetOrganizaciaOrganizacie', 'organizaciaId', organizaciaId)
            const localVarPath = `/organizacie/{organizaciaId}`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ziskanie zoznamu osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [q] Vyhľadávacia query
         * @param {'AKTIVNY' | 'NEAKTIVNY'} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOsobaListOrganizacie: async (organizaciaId: string, q?: string, stavZCykl?: 'AKTIVNY' | 'NEAKTIVNY', stavZCyklCas?: string, zaradenie?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalGetOrganizaciaOsobaListOrganizacie', 'organizaciaId', organizaciaId)
            const localVarPath = `/organizacie/{organizaciaId}/osoby`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (stavZCykl !== undefined) {
                localVarQueryParameter['stavZCykl'] = stavZCykl;
            }

            if (stavZCyklCas !== undefined) {
                localVarQueryParameter['stavZCyklCas'] = (stavZCyklCas as any instanceof Date) ?
                    (stavZCyklCas as any).toISOString() :
                    stavZCyklCas;
            }

            if (zaradenie !== undefined) {
                localVarQueryParameter['zaradenie'] = zaradenie;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOsobaOrganizacie: async (organizaciaId: string, osobaOrgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalGetOrganizaciaOsobaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'osobaOrgId' is not null or undefined
            assertParamExists('portalGetOrganizaciaOsobaOrganizacie', 'osobaOrgId', osobaOrgId)
            const localVarPath = `/organizacie/{organizaciaId}/osoby/{osobaOrgId}`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)))
                .replace(`{${"osobaOrgId"}}`, encodeURIComponent(String(osobaOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zoznamu zaradení osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaZaradeniaListOrganizacie: async (organizaciaId: string, stavZCykl?: string, stavZCyklCas?: string, zaradenie?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalGetOrganizaciaZaradeniaListOrganizacie', 'organizaciaId', organizaciaId)
            const localVarPath = `/organizacie/{organizaciaId}/zaradeniaOsoby`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (stavZCykl !== undefined) {
                localVarQueryParameter['stavZCykl'] = stavZCykl;
            }

            if (stavZCyklCas !== undefined) {
                localVarQueryParameter['stavZCyklCas'] = (stavZCyklCas as any instanceof Date) ?
                    (stavZCyklCas as any).toISOString() :
                    stavZCyklCas;
            }

            if (zaradenie !== undefined) {
                localVarQueryParameter['zaradenie'] = zaradenie;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zaradenia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaZaradenieOrganizacie: async (organizaciaId: string, zaradenieOsobyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalGetOrganizaciaZaradenieOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'zaradenieOsobyId' is not null or undefined
            assertParamExists('portalGetOrganizaciaZaradenieOrganizacie', 'zaradenieOsobyId', zaradenieOsobyId)
            const localVarPath = `/organizacie/{organizaciaId}/zaradeniaOsoby/{zaradenieOsobyId}`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)))
                .replace(`{${"zaradenieOsobyId"}}`, encodeURIComponent(String(zaradenieOsobyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zneplatnenie aktívnej osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateOrganizaciaOsobaOrganizacie: async (organizaciaId: string, osobaOrgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalInvalidateOrganizaciaOsobaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'osobaOrgId' is not null or undefined
            assertParamExists('portalInvalidateOrganizaciaOsobaOrganizacie', 'osobaOrgId', osobaOrgId)
            const localVarPath = `/organizacie/{organizaciaId}/osoby/{osobaOrgId}/zneplatnenie`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)))
                .replace(`{${"osobaOrgId"}}`, encodeURIComponent(String(osobaOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho zaradenia osoby subjektu - organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateSubjektOrgZaradenieOrganizacie: async (organizaciaId: string, zaradenieOsobyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalInvalidateSubjektOrgZaradenieOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'zaradenieOsobyId' is not null or undefined
            assertParamExists('portalInvalidateSubjektOrgZaradenieOrganizacie', 'zaradenieOsobyId', zaradenieOsobyId)
            const localVarPath = `/organizacie/{organizaciaId}/zaradeniaOsoby/{zaradenieOsobyId}/zneplatnenie`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)))
                .replace(`{${"zaradenieOsobyId"}}`, encodeURIComponent(String(zaradenieOsobyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalOverOsobuOrganizacieOrganizacie: async (osobaOrganizacieId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaOrganizacieId' is not null or undefined
            assertParamExists('portalOverOsobuOrganizacieOrganizacie', 'osobaOrganizacieId', osobaOrganizacieId)
            const localVarPath = `/organizacie/{osobaOrganizacieId}/over`
                .replace(`{${"osobaOrganizacieId"}}`, encodeURIComponent(String(osobaOrganizacieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Over možnosť overenia osoby organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalOverenieIsAllowedOrganizacie: async (osobaOrganizacieId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaOrganizacieId' is not null or undefined
            assertParamExists('portalOverenieIsAllowedOrganizacie', 'osobaOrganizacieId', osobaOrganizacieId)
            const localVarPath = `/organizacie/{osobaOrganizacieId}/overenie-povolene`
                .replace(`{${"osobaOrganizacieId"}}`, encodeURIComponent(String(osobaOrganizacieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spracuj neoverené osoby na organizácii
         * @param {Array<OsobaOrganizacie>} osobaOrganizacie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProcessNeovereneOsobyOrganizacie: async (osobaOrganizacie: Array<OsobaOrganizacie>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaOrganizacie' is not null or undefined
            assertParamExists('portalProcessNeovereneOsobyOrganizacie', 'osobaOrganizacie', osobaOrganizacie)
            const localVarPath = `/organizacie/spracuj-neoverene-osoby`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=utf-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(osobaOrganizacie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Editácia organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOrganizaciaOrganizacie: async (organizaciaId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalUpdateOrganizaciaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalUpdateOrganizaciaOrganizacie', 'body', body)
            const localVarPath = `/organizacie/{organizaciaId}`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Editácia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOrganizaciaOsobaOrganizacie: async (organizaciaId: string, osobaOrgId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizaciaId' is not null or undefined
            assertParamExists('portalUpdateOrganizaciaOsobaOrganizacie', 'organizaciaId', organizaciaId)
            // verify required parameter 'osobaOrgId' is not null or undefined
            assertParamExists('portalUpdateOrganizaciaOsobaOrganizacie', 'osobaOrgId', osobaOrgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalUpdateOrganizaciaOsobaOrganizacie', 'body', body)
            const localVarPath = `/organizacie/{organizaciaId}/osoby/{osobaOrgId}`
                .replace(`{${"organizaciaId"}}`, encodeURIComponent(String(organizaciaId)))
                .replace(`{${"osobaOrgId"}}`, encodeURIComponent(String(osobaOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizacieApi - functional programming interface
 * @export
 */
export const OrganizacieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizacieApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vytvorenie novej osoby organizácie (režim asociácie Osoby)
         * @param {string} organizaciaId Organizácia ID
         * @param {OsobaOrganizacieAssign} osobaOrganizacieAssign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAssignOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrganizacieAssign: OsobaOrganizacieAssign, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsobaOrganizacie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAssignOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrganizacieAssign, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Priradenie zaradení osobám organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {Array<OsobaOrganizacieZaradenieCreate>} osobaOrganizacieZaradenieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId: string, osobaOrganizacieZaradenieCreate: Array<OsobaOrganizacieZaradenieCreate>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId, osobaOrganizacieZaradenieCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOrganizaciaOrganizacie(organizaciaId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organizacia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOrganizaciaOrganizacie(organizaciaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ziskanie zoznamu osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [q] Vyhľadávacia query
         * @param {'AKTIVNY' | 'NEAKTIVNY'} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOrganizaciaOsobaListOrganizacie(organizaciaId: string, q?: string, stavZCykl?: 'AKTIVNY' | 'NEAKTIVNY', stavZCyklCas?: string, zaradenie?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OsobaOrganizacie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOrganizaciaOsobaListOrganizacie(organizaciaId, q, stavZCykl, stavZCyklCas, zaradenie, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsobaOrganizacie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zoznamu zaradení osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId: string, stavZCykl?: string, stavZCyklCas?: string, zaradenie?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OsobaOrganizacieZaradenie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId, stavZCykl, stavZCyklCas, zaradenie, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zaradenia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOrganizaciaZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsobaOrganizacieZaradenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOrganizaciaZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zneplatnenie aktívnej osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho zaradenia osoby subjektu - organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Over možnosť overenia osoby organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalOverenieIsAllowedOrganizacie(osobaOrganizacieId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalOverenieIsAllowedOrganizacie(osobaOrganizacieId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Spracuj neoverené osoby na organizácii
         * @param {Array<OsobaOrganizacie>} osobaOrganizacie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie: Array<OsobaOrganizacie>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Editácia organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalUpdateOrganizaciaOrganizacie(organizaciaId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organizacia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalUpdateOrganizaciaOrganizacie(organizaciaId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Editácia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsobaOrganizacie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizacieApi - factory interface
 * @export
 */
export const OrganizacieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizacieApiFp(configuration)
    return {
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvorenie novej osoby organizácie (režim asociácie Osoby)
         * @param {string} organizaciaId Organizácia ID
         * @param {OsobaOrganizacieAssign} osobaOrganizacieAssign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAssignOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrganizacieAssign: OsobaOrganizacieAssign, options?: any): AxiosPromise<OsobaOrganizacie> {
            return localVarFp.portalAssignOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrganizacieAssign, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Priradenie zaradení osobám organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {Array<OsobaOrganizacieZaradenieCreate>} osobaOrganizacieZaradenieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId: string, osobaOrganizacieZaradenieCreate: Array<OsobaOrganizacieZaradenieCreate>, options?: any): AxiosPromise<void> {
            return localVarFp.portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId, osobaOrganizacieZaradenieCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOrganizacie(organizaciaId: string, options?: any): AxiosPromise<Organizacia> {
            return localVarFp.portalGetOrganizaciaOrganizacie(organizaciaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ziskanie zoznamu osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [q] Vyhľadávacia query
         * @param {'AKTIVNY' | 'NEAKTIVNY'} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOsobaListOrganizacie(organizaciaId: string, q?: string, stavZCykl?: 'AKTIVNY' | 'NEAKTIVNY', stavZCyklCas?: string, zaradenie?: string, options?: any): AxiosPromise<Array<OsobaOrganizacie>> {
            return localVarFp.portalGetOrganizaciaOsobaListOrganizacie(organizaciaId, q, stavZCykl, stavZCyklCas, zaradenie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: any): AxiosPromise<OsobaOrganizacie> {
            return localVarFp.portalGetOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zoznamu zaradení osôb organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId: string, stavZCykl?: string, stavZCyklCas?: string, zaradenie?: string, options?: any): AxiosPromise<Array<OsobaOrganizacieZaradenie>> {
            return localVarFp.portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId, stavZCykl, stavZCyklCas, zaradenie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zaradenia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOrganizaciaZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: any): AxiosPromise<OsobaOrganizacieZaradenie> {
            return localVarFp.portalGetOrganizaciaZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zneplatnenie aktívnej osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho zaradenia osoby subjektu - organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Over osobu organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Over možnosť overenia osoby organizácie
         * @param {string} osobaOrganizacieId Osoba Organizácie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalOverenieIsAllowedOrganizacie(osobaOrganizacieId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.portalOverenieIsAllowedOrganizacie(osobaOrganizacieId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spracuj neoverené osoby na organizácii
         * @param {Array<OsobaOrganizacie>} osobaOrganizacie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie: Array<OsobaOrganizacie>, options?: any): AxiosPromise<void> {
            return localVarFp.portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Editácia organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOrganizaciaOrganizacie(organizaciaId: string, body: object, options?: any): AxiosPromise<Organizacia> {
            return localVarFp.portalUpdateOrganizaciaOrganizacie(organizaciaId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Editácia osoby organizácie
         * @param {string} organizaciaId Organizácia ID
         * @param {string} osobaOrgId Osoba organizácie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, body: object, options?: any): AxiosPromise<OsobaOrganizacie> {
            return localVarFp.portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizacieApi - object-oriented interface
 * @export
 * @class OrganizacieApi
 * @extends {BaseAPI}
 */
export class OrganizacieApi extends BaseAPI {
    /**
     * 
     * @summary Over osobu organizácie
     * @param {string} osobaOrganizacieId Osoba Organizácie ID
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalAllowPozadovaneZaradeniaOrganizacie(osobaOrganizacieId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvorenie novej osoby organizácie (režim asociácie Osoby)
     * @param {string} organizaciaId Organizácia ID
     * @param {OsobaOrganizacieAssign} osobaOrganizacieAssign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalAssignOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrganizacieAssign: OsobaOrganizacieAssign, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalAssignOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrganizacieAssign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Priradenie zaradení osobám organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {Array<OsobaOrganizacieZaradenieCreate>} osobaOrganizacieZaradenieCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId: string, osobaOrganizacieZaradenieCreate: Array<OsobaOrganizacieZaradenieCreate>, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalAssignOrganizaciaZaradeniaOrganizacie(organizaciaId, osobaOrganizacieZaradenieCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalGetOrganizaciaOrganizacie(organizaciaId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalGetOrganizaciaOrganizacie(organizaciaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ziskanie zoznamu osôb organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} [q] Vyhľadávacia query
     * @param {'AKTIVNY' | 'NEAKTIVNY'} [stavZCykl] Stav životného cyklu
     * @param {string} [stavZCyklCas] Stav životného cyklu v čase
     * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalGetOrganizaciaOsobaListOrganizacie(organizaciaId: string, q?: string, stavZCykl?: 'AKTIVNY' | 'NEAKTIVNY', stavZCyklCas?: string, zaradenie?: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalGetOrganizaciaOsobaListOrganizacie(organizaciaId, q, stavZCykl, stavZCyklCas, zaradenie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie osoby organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} osobaOrgId Osoba organizácie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalGetOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalGetOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zoznamu zaradení osôb organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} [stavZCykl] Stav životného cyklu
     * @param {string} [stavZCyklCas] Stav životného cyklu v čase
     * @param {string} [zaradenie] Zaradenie osoby na subjekte - organizácii. Viaceré zaradenia oddelené čiarkou (aplikuje sa OR logika).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId: string, stavZCykl?: string, stavZCyklCas?: string, zaradenie?: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalGetOrganizaciaZaradeniaListOrganizacie(organizaciaId, stavZCykl, stavZCyklCas, zaradenie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zaradenia osoby organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalGetOrganizaciaZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalGetOrganizaciaZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zneplatnenie aktívnej osoby organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} osobaOrgId Osoba organizácie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalInvalidateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zneplatnenie aktívneho zaradenia osoby subjektu - organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} zaradenieOsobyId Zaradenie osoby v organizácii ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId: string, zaradenieOsobyId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalInvalidateSubjektOrgZaradenieOrganizacie(organizaciaId, zaradenieOsobyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Over osobu organizácie
     * @param {string} osobaOrganizacieId Osoba Organizácie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalOverOsobuOrganizacieOrganizacie(osobaOrganizacieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Over možnosť overenia osoby organizácie
     * @param {string} osobaOrganizacieId Osoba Organizácie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalOverenieIsAllowedOrganizacie(osobaOrganizacieId: string, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalOverenieIsAllowedOrganizacie(osobaOrganizacieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spracuj neoverené osoby na organizácii
     * @param {Array<OsobaOrganizacie>} osobaOrganizacie 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie: Array<OsobaOrganizacie>, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalProcessNeovereneOsobyOrganizacie(osobaOrganizacie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Editácia organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalUpdateOrganizaciaOrganizacie(organizaciaId: string, body: object, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalUpdateOrganizaciaOrganizacie(organizaciaId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Editácia osoby organizácie
     * @param {string} organizaciaId Organizácia ID
     * @param {string} osobaOrgId Osoba organizácie ID
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizacieApi
     */
    public portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId: string, osobaOrgId: string, body: object, options?: AxiosRequestConfig) {
        return OrganizacieApiFp(this.configuration).portalUpdateOrganizaciaOsobaOrganizacie(organizaciaId, osobaOrgId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
